import { DataType } from './data-type';

export class KnownPropertyTypes {
    public static map: { [id: string]: number } = {};
    private static toServicePropertyMap: { [id: string]: string } = {};
    private static fromServicePropertyMap: { [id: string]: string } = {};

    public static forValidationType(validationType: string): number {
        switch (validationType) {
            case 'Duration':
                return DataType.STRING;
            case 'Time':
                return DataType.DATE;
            case 'MOSDateTime':
                return DataType.DATE;
            case 'CheckBox':
                return DataType.BOOL;
            case 'Text':
                return DataType.STRING;
            case 'MOSAutomation':
                return DataType.OBJECT;
            case 'StaffIDList':
                return DataType.STRING;
            case 'Date':
                return DataType.DATE;
            case 'ComboBox':
                return DataType.STRING;
            case 'CheckList':
                return DataType.MULTIVALUE;
            // TODO: This needs to be fixed later
            case 'Table':
                return DataType.STRING;
            case 'MOSAutomationDuration':
                return DataType.STRING;
            default:
                throw `Validation Type mapping not implemented for ${validationType}`;
        }
    }

    public static for(property: string): number {
        return KnownPropertyTypes.map[property];
    }

    public static setFor(propertyTypes: { [id: string]: number }) {
        for (const property in propertyTypes) {
            KnownPropertyTypes.map[property] = propertyTypes[property];
        }
    }
}
